export const SET_ASSETS_TO_PREVIEW = 'SET_ASSETS_TO_PREVIEW';
export const UPDATE_ASSET_TO_PREVIEW = 'UPDATE_ASSET_TO_PREVIEW';